import { XIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { yeshumanUiSans } from '@/components/landing/yeshuman/yeshuman-typography'
import { Button } from '@/components/ui/button'
import { SheetClose, SheetTitle } from '@/components/ui/sheet'
import { cn } from '@/lib/utils'

/**
 * Landing contact pane header — close on top, larger title below.
 * Edit freely — does not affect the in-app Artifact Canvas.
 */
export function YeshumanContactSheetHeader({
  title,
  trailing,
  className,
}: {
  title: ReactNode
  trailing?: ReactNode
  className?: string
}) {
  return (
    <header className={cn('flex shrink-0 flex-col gap-3 border-0 px-6 pt-5 pb-0', className)}>
      <div className="flex items-center gap-2">
        <SheetClose asChild>
          <Button
            type="button"
            variant="ghost"
            size="iconSm"
            aria-label="Close"
            title="Close"
            className={cn(
              '-ml-1 rounded-none text-[var(--marketing-text)] opacity-70 shadow-none',
              'hover:bg-transparent hover:opacity-100 hover:text-[var(--marketing-text)]',
              'focus-visible:ring-0 focus-visible:outline focus-visible:outline-2',
              'focus-visible:outline-offset-4 focus-visible:outline-[var(--marketing-gold)]',
            )}
          >
            <XIcon className="size-5" aria-hidden />
          </Button>
        </SheetClose>
        {trailing ? <div className="ml-auto shrink-0">{trailing}</div> : null}
      </div>

      <SheetTitle
        className={cn(
          yeshumanUiSans,
          'text-[1.625rem] font-medium leading-[1.2] tracking-[-0.02em]',
          'text-[var(--marketing-text)]',
        )}
      >
        {title}
      </SheetTitle>
    </header>
  )
}
